'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_AppPage$DocumentsCreateOfType(kind, basedOn) {
  this.M3 = null;
  this.M2 = null;
  this.M3 = kind;
  this.M2 = basedOn;
}
export { $c_Lapp_pages_AppPage$DocumentsCreateOfType as $c_Lapp_pages_AppPage$DocumentsCreateOfType };
$p = $c_Lapp_pages_AppPage$DocumentsCreateOfType.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_AppPage$DocumentsCreateOfType;
/** @constructor */
function $h_Lapp_pages_AppPage$DocumentsCreateOfType() {
}
export { $h_Lapp_pages_AppPage$DocumentsCreateOfType as $h_Lapp_pages_AppPage$DocumentsCreateOfType };
$h_Lapp_pages_AppPage$DocumentsCreateOfType.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_AppPage$DocumentsCreateOfType)) {
    var x = this.M3;
    var x$2 = x$0.M3;
    if ((x === x$2)) {
      var x$3 = this.M2;
      var x$4 = x$0.M2;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "DocumentsCreateOfType";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.M3;
  }
  if ((n === 1)) {
    return this.M2;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "kind";
  }
  if ((n === 1)) {
    return "basedOn";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_pages_AppPage$DocumentsCreateOfType(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k9)));
}
export { $isArrayOf_Lapp_pages_AppPage$DocumentsCreateOfType as $isArrayOf_Lapp_pages_AppPage$DocumentsCreateOfType };
var $d_Lapp_pages_AppPage$DocumentsCreateOfType = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_AppPage$DocumentsCreateOfType, "app.pages.AppPage$DocumentsCreateOfType", ({
  k9: 1,
  aB: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_pages_AppPage$DocumentsCreateOfType as $d_Lapp_pages_AppPage$DocumentsCreateOfType };
//# sourceMappingURL=app.pages.-App-Page$-Documents-Create-Of-Type.js.map
